import { 
    RequestOptions, Response, ResponseOptions } from '@angular/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/throw';
import { Router } from '@angular/router';
import { VcaAlertsService } from '../vca-alerts';
import { Subject } from 'rxjs/Subject';
import { HttpUtils } from './http-utils';
import { environment } from 'environments/environment';
import { HttpClient, HttpHandler, HttpHeaders, HttpRequest } from '@angular/common/http';

@Injectable()
export class CustomHttp extends HttpClient {

    public static unAuthorizedEvent: Subject<any> = new Subject<any>();
    private defaultRequestHeaders: Map<string, string|string[]> = null;
    constructor(backend: HttpHandler,
        private defaultOptions: RequestOptions, private router: Router,
        private alert: VcaAlertsService) {
        super(backend);
       
        this.defaultRequestHeaders = new Map<string, string|string[]>();
        defaultOptions.headers.forEach((value, header) => {
            this.defaultRequestHeaders.set(header, value);
        });
    }

    private setRequestDefaults(options: any): any {
        options = options || {};
        options.headers = options.headers || new HttpHeaders();
        this.defaultRequestHeaders.forEach((v, k) => {
          if (options.headers instanceof HttpHeaders) {
            options.headers = options.headers.append(k, v);
          }
        });
    
        return options;
    }
    

    public static setunAuthorizedEvent(event: string): void {
        this.unAuthorizedEvent.next(event);
    }

    public static getunAuthorizedEvent(): Observable<any> {
        return this.unAuthorizedEvent.asObservable();
    }

    isUnauthorized(status: number) {
        return status === 401;
    }

    handleGetError(err: any) {
        if (this.isUnauthorized(err.status)) {
            this.routeToLoginPage();
        } else if (err.status === 503) {
            this.routeToServiceUnavailablePage();
        } else {
            let errorMessageArray = [];
            let errBody: any;
            try {
                errBody = err;
                if ( errBody.message ) {
                    errorMessageArray.push(errBody.message);
                } else if ( errBody.errorMessage ) {
                    errorMessageArray.push(errBody.errorMessage);
                }
            } catch (e) {
                if (err._body) {
                    errBody = err._body;
                    errorMessageArray.push(errBody);
                }
            }
            if ( errorMessageArray.length > 0) {
                this.alert.danger(errorMessageArray, 'get-calls-error-alert');
            }
        }
    }

    handleError(err: any) {
        if (this.isUnauthorized(err.status)) {
            // Incase of remote plugin when 401 response seen, do not process further.We have error handler for the workflow.
            if(!environment.loadedInVCRemotePlugin) {
                this.routeToLoginPage();
            }
        } else if (err.status < 200 || err.status >= 300) {
            let errorMessageArray = [];
            let errBody: any;
            try {
                errBody = err;
                if ( errBody.message ) {
                    errorMessageArray.push(errBody.message);
                } else if ( errBody.errorMessage ) {
                    errorMessageArray.push(errBody.errorMessage);
                }
            } catch (e) {
                if (err._body) {
                    errBody = err._body;
                    errorMessageArray.push(errBody);
                }
            }
            if ( errorMessageArray.length > 0) {
                this.alert.danger(errorMessageArray, 'post-put-delete-calls-error-alert');
            }else {
                this.alert.danger(['Operation Failed to proceed.'], 'post-put-delete-calls-error-alert'); // if failed and no error messages from BE
            }
        }
    }

    getErrorResponse() {
        let errorMessage  = "HCX manager is deactivated. Please contact support.";
        let errorCode     =  401;
        this.alert.danger([errorMessage], 'post-put-delete-calls-error-alert');
        return (Observable.throw(new Response(
            new ResponseOptions({
                body: {
                    "errorMessage": errorMessage
                },
                status: errorCode
        }))));
    }

    public routeToLoginPage() {
       // Todo: Route to the login page, but currently we don't have login route.
       // once we have route we will add here.
        this.alert.warning('Session has expired. Please login again.');
        CustomHttp.setunAuthorizedEvent('LOGOUT_USER');
    }

    routeToServiceUnavailablePage() {
        this.router.navigate(['/unavailable']);
    }

    get(url: string, options?: any): Observable<any> {
        options = this.setRequestDefaults(options);
        let response = super.get(url, options);
        response = response.do(undefined, err => this.handleGetError(err));
        return response;
    }


    post(url: string, body: any, options?: any): Observable<any> {
        options = this.setRequestDefaults(options);
        if ( HttpUtils.isNspDeactivated(url) ) {
            return this.getErrorResponse();
        }
        let response = super.post(url, body, options);
        response = response.do(undefined, err => this.handleError(err));
        return response;
    }

    put(url: string, body: any, options?: any): Observable<any> {
        options = this.setRequestDefaults(options);
        if ( HttpUtils.isNspDeactivated(url) ) {
            return this.getErrorResponse();
        }      
        let response = super.put(url, body, options);
        response = response.do(undefined, err => this.handleError(err));
        return response;
    }

    delete(url: string, options?: any): Observable<any> {
        options = this.setRequestDefaults(options);
        if ( HttpUtils.isNspDeactivated(url) ) {
            return this.getErrorResponse();
        }    
        let response = super.delete(url, options);
        response = response.do(undefined, err => this.handleError(err));
        return response;
    }
}




// WEBPACK FOOTER //
// ./src/common/http/custom-http.ts